"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/home/circleci/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var useCMSIcon_1 = __importDefault(require("./useCMSIcon"));

var Container = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // make the SVG responsive so it takes the size of the parent;\n  // stop it from sending mouseout events to the parent\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > svg {\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n  }\n"])));
var CMSIcon = react_1.default.forwardRef(function (_a, ref) {
  var name = _a.name,
      color = _a.color,
      hoverColor = _a.hoverColor,
      _a$noEmitError = _a.noEmitError,
      noEmitError = _a$noEmitError === void 0 ? false : _a$noEmitError,
      props = __rest(_a, ["name", "color", "hoverColor", "noEmitError"]);

  var _ref = (0, react_1.useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      hover = _ref2[0],
      setHover = _ref2[1];

  var icon = (0, useCMSIcon_1.default)(name, hover && hoverColor ? hoverColor : color, noEmitError);
  if (!icon) return react_1.default.createElement(react_1.default.Fragment, null); // only add mouseEnter and mouseLeave events
  // if there is a hover color specified

  var mouseHandlers = {};
  if (hoverColor) mouseHandlers = {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  };
  return react_1.default.createElement(Container, Object.assign({}, props, {
    ref: ref,
    role: "img",
    "aria-label": icon.text,
    dangerouslySetInnerHTML: {
      __html: icon.svg
    }
  }, mouseHandlers));
});
exports.default = CMSIcon;